module.exports = __webpack_public_path__ + "img/product6.374fe95c.png";